import { useState } from "react";
import useCartStore from "../../utils/cartStore";
import { TABLETTES } from "../../data/tablettes";

const COLORS = ["Noir", "Lait", "Blanc", "Gold", "Ruby"];

const BoxDecouverte = () => {
  const addToCart = useCartStore((state) => state.addToCart);
  const [selectedTablet, setSelectedTablet] = useState(null);
  const [composition, setComposition] = useState({
    Noir: 0,
    Lait: 0,
    Blanc: 0,
    Gold: 0,
    Ruby: 0
  });

  const totalPieces = Object.values(composition).reduce((a, b) => a + b, 0);

  const handleChange = (color, value) => {
    const newComposition = {
      ...composition,
      [color]: Number(value)
    };
    const newTotal = Object.values(newComposition).reduce((a, b) => a + b, 0);
    if (newTotal <= 8) {
      setComposition(newComposition);
    }
  };

  const handleAddToCart = () => {
    if (!selectedTablet) {
      alert("Choisissez une tablette");
      return;
    }
    if (totalPieces !== 8) {
      alert("Vous devez choisir exactement 8 mendiants");
      return;
    }
    const descriptionMendiants = COLORS
      .map(c => composition[c] ? `${composition[c]} ${c}` : null)
      .filter(Boolean)
      .join(", ");
    addToCart(
      {
        id: `box-decouverte-${Date.now()}`,
        name: "Box Découverte",
        price: 20,
        image: "/images/box-decouverte.jpg",
        category: "Box Découverte",
        description: `
Tablette: ${selectedTablet.name}
Mendiants: ${descriptionMendiants}
        `
      },
      1
    );
  };

  return (
    <div className="section-padding">
      <h1 className="text-4xl font-bold mb-6">Box Découverte</h1>

      {/* Description + Photo */}
      <div className="flex flex-col md:flex-row gap-6 bg-white rounded-2xl shadow p-6 mb-12 items-center">
        <img
          src="/images/categories/box_decouverte_cat.jpg"
          alt="Box Découverte"
          className="w-full md:w-56 h-44 object-contain rounded-xl bg-gray-50 flex-shrink-0"
        />
        <div>
          <h2 className="text-xl font-semibold mb-2">Qu'est-ce que la Box Découverte ?</h2>
          <p className="text-gray-600 text-sm leading-relaxed mb-3">
            La Box Découverte est le coffret idéal pour se faire plaisir ou offrir un cadeau gourmand et original.
            Elle contient <span className="font-semibold">1 tablette de chocolat</span> et <span className="font-semibold">8 mendiants</span>, entièrement personnalisables selon vos goûts.
          </p>
          <ul className="text-sm text-gray-600 space-y-1">
            <li>🍫 <span className="font-medium">1 tablette</span> au choix parmi notre sélection</li>
            <li>🍬 <span className="font-medium">8 mendiants</span> à composer librement (Noir, Lait, Blanc, Gold, Ruby)</li>
            <li>🎁 Présentée dans un joli coffret cadeau</li>
          </ul>
          <p className="text-primary font-bold text-lg mt-3">20 €</p>
        </div>
      </div>

      {/* TABLETTES */}
      <h2 className="text-2xl font-semibold mb-6">Choisissez votre tablette</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
        {TABLETTES.map((tablet) => (
          <div
            key={tablet.id}
            onClick={() => setSelectedTablet(tablet)}
            className={`p-4 border rounded-xl cursor-pointer ${
              selectedTablet?.id === tablet.id
                ? "border-primary bg-primary/10"
                : ""
            }`}
          >
            <img
              src={tablet.image}
              alt={tablet.name}
              className="w-full h-40 object-contain rounded-lg mb-3"
            />
            <h3 className="font-semibold">{tablet.name}</h3>
          </div>
        ))}
      </div>

      {/* MENDIANTS */}
      <h2 className="text-2xl font-semibold mb-6">Choisissez 8 mendiants</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6 mb-6">
        {COLORS.map(color => (
          <div key={color}>
            <label className="block mb-2 font-medium">{color}</label>
            <input
              type="number"
              min="0"
              max="8"
              value={composition[color]}
              onChange={(e) => handleChange(color, e.target.value)}
              className="w-full border rounded-lg px-3 py-2"
            />
          </div>
        ))}
      </div>

      <p className="mb-6 text-gray-600">{totalPieces} / 8 pièces sélectionnées</p>

      <button onClick={handleAddToCart} className="btn-primary">
        Ajouter la box au panier (20 €)
      </button>
    </div>
  );
};

export default BoxDecouverte;